/**
 * Created by Pradeep Kumar on 05/23/2019.
 */

import {ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {TombOfNefertitiGameConfig} from "../../TombOfNefertitiGameConfig";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {TweenLite} from "gsap";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/core/component/BitmapCountUp";

export class TombOfNefertitiFreeSpinOutroView extends ScreenView {

    private _finalMultiplierAmountItem: BitmapCountUp;
    private _freeSpinsPlayedAmountItem: BitmapCountUp;

    private _container: PIXI.Container;

    show(data?: ParsedServerData, onShowComplete?: () => void): void {
        const duration: number = 0.5;

        data = data!;

        this._finalMultiplierAmountItem.getCountUpAnimation(data.currentMultiplier, data.currentMultiplier, {duration: 0});
        this._freeSpinsPlayedAmountItem.getCountUpAnimation(data.numberOfFreespinsPlayed!, data.numberOfFreespinsPlayed!, {duration: 0});

        super.show(data, onShowComplete);

        for (let i: number = 0; i < this._container.children.length; ++i) {
            this._container.children[i].visible = true;
            this._container.children[i].alpha = 0;
            TweenLite.to(this._container.children[i], duration, {
                alpha: 1
            });
        }
    }

    close(closeCallback?: () => void): void {
        super.close(closeCallback);
        TombOfNefertitiGameConfig.instance.FS_OUTRO_VISIBLE = false;

        for (let i: number = 0; i < this._container.children.length; ++i) {
            this._container.children[i].visible = false;
        }
    }

    protected createGameGraphics(): PIXI.DisplayObject {
        const container: PIXI.Container = new PIXI.Container(),
            textStyle: TextStyleOptions = {
                fill: ["#fbbd16", "#fff47b", "#fbbd16"],
                fillGradientStops: [0.1, 0.5, 0.9],
                fillGradientType: 0,
                fontSize: 30,
                fontFamily: TombOfNefertitiGameConfig.instance.USABLE_FONT,
                dropShadow: true,
                dropShadowAlpha: 1,
                dropShadowAngle: 90,
                dropShadowBlur: 6,
                dropShadowColor: "#250e08",
                dropShadowDistance: 5,
                padding: 8,
                stroke: "#4a1703",
                strokeThickness: 4
            },
            yPosMultiplier: number = 60,
            startY: number = 300;

        let finalMultiplier = new PIXI.Text(Translation.translate("FINAL TOMB MULTIPLIER"), textStyle),
            freeSpinsPlayed = new PIXI.Text(Translation.translate("RAIDER SPINS PLAYED"), textStyle);

        finalMultiplier.anchor.set(0.5);
        freeSpinsPlayed.anchor.set(0.5);

        this._finalMultiplierAmountItem = new BitmapCountUp({
            style: {
                font: {
                    name: "nefertitiCountUp",
                    size: 80
                },
                tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
            },
            numberFormat: {
                precision: 0
            }
        });
        this._finalMultiplierAmountItem.maxTextWidth = TombOfNefertitiGameConfig.instance.GAME_WIDTH;

        this._freeSpinsPlayedAmountItem = new BitmapCountUp({
            style: {
                font: {
                    name: "nefertitiCountUp",
                    size: 80
                },
                tint: parseInt(("#FFFFFF").replace(/^#/, ''), 16)
            },
            numberFormat: {
                precision: 0
            }
        });
        this._freeSpinsPlayedAmountItem.maxTextWidth = TombOfNefertitiGameConfig.instance.GAME_WIDTH;

        container.addChild(finalMultiplier);
        container.addChild(this._finalMultiplierAmountItem);
        container.addChild(freeSpinsPlayed);
        container.addChild(this._freeSpinsPlayedAmountItem);

        for (let i: number = 0; i < container.children.length; ++i) {
            container.children[i].y = (i + 1) * yPosMultiplier + startY;
            container.children[i].visible = false;
        }

        this._container = container;

        return container;
    }

    protected onResizeGameGraphics(resizeData: IResizeData): void {
        super.onResizeGameGraphics && super.onResizeGameGraphics(resizeData);

        const offsetY: number = -370;

        this._container.y = this._screenHeight / 2 + offsetY;

        for (let i: number = 0; i < this._container.children.length; ++i) {
            this._container.children[i].x = this._screenWidth / 2;
        }
    }
}